// extracted by mini-css-extract-plugin
export default {"Flash":"PublishBanners-module__Flash--RM5Rx"};